import React, { useState, useEffect, useRef } from 'react';
import jwt from 'expo-jwt';
import axios from 'axios';
import { Container, Typography, TextField, Button, Box, Stack, CircularProgress } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch } from 'react-redux';
import { purgeOrganiztion, setOrganizationData, setUserToken, setAccessToken, setRefreshToken, setUserData, setCdn, setVsCdn } from '@modules/organization';
import { purgeChapter } from '@modules/chapter';
import { purgeEditor } from '@modules/editor';
import { purgeMedia } from '@modules/media';
import { purgeSubtitle } from '@modules/subtitle';
import { toast, Flip } from 'react-toastify';
import api, { getDeviceId } from '@utils/axiosInstance';

import LoadingComponent from '../../components/_commons/LoadingComponent';
import '@resources/assets/styles/login.scss';
import 'react-toastify/dist/ReactToastify.css';

import Unavailable from './Unavailable';

function Login({ orgList }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toastId = useRef(null);

  const [orgCode, setOrgCode] = useState('');
  const [noMatchOrg, setNoMatchOrg] = useState(false);
  const [openKey, setOpenKey] = useState('');
  const [logoImg, setLogoImg] = useState('');
  const [user_id, setUserId] = useState('');
  const [user_password, setUserPassword] = useState('');
  const [tryLogin, setTryLogin] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const url = window.location.href;
    const urlObj = new URL(url);
    const pathParts = urlObj.hostname.split('.');
    setOrgCode(pathParts[0]);
  }, []);

  useEffect(() => {
    orgCode && setLogoImg("https://mpvldhluuktv5373941.cdn.ntruss.com/logo/" + orgCode + "_logo.png")
  }, [orgCode])

  useEffect(() => {
    console.log("orgList", orgCode, orgList)

    setIsLoading(false);
    if (orgCode && orgList.length > 0) {
      const matchingOrg = orgList && orgList.find(org => org.value === orgCode);
      if (matchingOrg) {

        dispatch(purgeOrganiztion());
        dispatch(purgeMedia());
        dispatch(purgeOrganiztion());
        dispatch(purgeEditor());
        dispatch(purgeSubtitle());
        dispatch(purgeChapter());

        var organizationData = {
          organization_name: matchingOrg.label,
          organization_code: matchingOrg.value
        }
        setOpenKey(matchingOrg.open_token);
        // localStorage.setItem('accessToken', matchingOrg.open_token); //추후 적용
        dispatch(setOrganizationData({ ...organizationData }));
      }
      else {
        setNoMatchOrg(true);
      }
    }
  }, [orgCode, orgList])

  const handleUserIDChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserId(e.target.value);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserPassword(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      tryAuthLogin();
    }
  };

  const tryAuthLogin = () => {

    console.log("tryAuthLogin");

    var authAllowed = true;
    var checkedUserID = user_id.trim();
    var checkedUserPassword = user_password.trim();

    if (checkedUserID == "" || checkedUserPassword == "") {
      authAllowed = false;

      toast.warn(t('auth.please_enter_all_info'), {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
        className: 'rotateY animated',
        transition: Flip
      });
    }
    else {
      toastId.current = toast.info(t('auth.logging_in'), {
        position: "top-center",
        transition: Flip,
        autoClose: 3000,
        theme: "colored",
        className: 'rotateY animated',
      }) as any; // 타입 오류 임시 우회
    }

    if (authAllowed) {
      setTryLogin(true);
      setLoginSuccess(null); // 로그인 시도 시 초기화
      var payload = {
        userid: checkedUserID,
        password: checkedUserPassword,
        timestamp: new Date()
      }

      var token = jwt.encode(payload, openKey);
      var data = {
        "token": token,
        "organization_code": orgCode
      };

      var config = {
        method: 'post',
        url: GK_API_URL + '/' + API_VERSION + '/auth/app/login',
        headers: {
          'Content-Type': 'application/json',
          'x-device-id': getDeviceId()
        },
        data: data
      };

      if (!tryLogin) {
        axios(config)
          .then((response) => {
            if (response.data.code == 100) {
              var data = response.data;
              var uToken = data.token;
              var extraToken = data.token.slice(-7);
              var userToken = data.token.replace(extraToken, '');
              localStorage.setItem('userToken', userToken);
              var decodedUserData = jwt.decode(userToken, openKey + extraToken);

              var userData = {}; // 디코딩 된 사용자 정보
              for (const [key, value] of Object.entries(decodedUserData)) {
                userData[key] = decodeURI(value);
              }
              dispatch(setUserToken(uToken));
              dispatch(setAccessToken(data.atk));
              localStorage.setItem('accessToken', data.atk);
              dispatch(setRefreshToken(data.rtk));
              localStorage.setItem('refreshToken', data.rtk);
              dispatch(setUserData({ ...userData }));
              // dispatch(setCdn(userData.media_cdn));
              // dispatch(setVsCdn(userData.media_vs_cdn));
              dispatch(setCdn('https://ungltzimaecm7395057.cdn.ntruss.com'));
              dispatch(setVsCdn('https://jaolyskypdfu7395038.cdn.ntruss.com'));
              setTryLogin(false);
              setLoginSuccess(true); // 로그인 성공
            }
            else {
              toast.update(toastId.current as any, {
                render: t('auth.invalid_user_info'),
                type: "warning",
                position: "top-center",
                autoClose: 3000,
                transition: Flip,
                theme: "colored",
              });
              setTryLogin(false);
              setLoginSuccess(false); // 로그인 실패
            }
          })
          .catch(function (error) {
            console.log(error);
            toast.update(toastId.current as any, {
              render: t('auth.unknown_error'),
              type: "error",
              position: "top-center",
              autoClose: 3000,
              className: 'rotateY animated',
              transition: Flip,
              theme: "colored",
            });
            setTryLogin(false);
            setLoginSuccess(false); // 로그인 실패
          });
      }
    }
  } //end Of tryAuthLogin

  return (
    <>
      {isLoading || tryLogin ? (
        <Container maxWidth="xs" style={{ width: 380, marginTop: '20%', textAlign: 'center' }}>
          <LoadingComponent />
        </Container>
      ) : noMatchOrg ? (
        <Unavailable />
      ) : loginSuccess === true ? (
        <Container maxWidth="xs" style={{ width: 380, marginTop: '20%', textAlign: 'center' }}>
          <Skeleton variant="rectangular" width={380} height={300} />
        </Container>
      ) : (
        <Container maxWidth="xs" style={{ width: 380, marginTop: '20%' }}>
          <Stack spacing={3} alignItems="center">
            <img
              src={logoImg}
              alt="Logo"
              style={{ width: '100%', maxWidth: 250, paddingBottom: '15%', height: 'auto' }}
            />
            <Box id="form-login" className="container-form-login">
              <TextField
                label={t('auth.user_id')}
                type="text"
                variant="outlined"
                fullWidth
                margin="normal"
                onChange={handleUserIDChange}
                onKeyDown={handleKeyDown}
              />
              <TextField
                label={t('auth.password')}
                type="password"
                variant="outlined"
                fullWidth
                margin="normal"
                onChange={handlePasswordChange}
                onKeyDown={handleKeyDown}
              />
              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                onClick={tryAuthLogin}
                type="submit"
                className="btn-login-submit"
              >
                {t('auth.login')}
              </Button>
            </Box>
          </Stack>
        </Container>
      )}
    </>
  );
}

export default Login;
